import React from 'react';
import Tooltip from '@mui/material/Tooltip';


const MenuItem = ({ isDisabled, title, imageClassName, logo, link }) => {

  return (
    <>
      {isDisabled ? (
        <div className="container-item container-item-disabled">
          <div className={imageClassName}>
            <img src={logo} alt="ICyte" />
          </div>
          <div className="text">
            {title}
          </div>
        </div>
      ) : (
        <a href={link} className="remove-link-decoration" target="_blank" rel="noreferrer" >
          <Tooltip title={title} arrow placement="top">
            <div className="container-item">
              <div className={imageClassName}>
                <img src={logo} alt="Icyte" />
              </div>
              <div className="text">
                {title}
              </div>
            </div>
          </Tooltip>
        </a>
      )}
    </>
  )
}

export default MenuItem